import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { Select } from "@components";

export default class AtenaAICatalogDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      catalogId: null,
    };
  }

  componentDidMount() {
    if (this.props.catalogId) {
      this.setState({ catalogId: this.props.catalogId });
    }
  }

  componentDidUpdate({ catalogId }) {
    if (this.props.catalogId && this.props.catalogId !== catalogId) {
      this.setState({ catalogId: this.props.catalogId });
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { catalogId } = this.state;

      this.setState({ loading: true });

      await onSave(catalogId);

      this.setState({ loading: false });
    } catch (e) {
      alert({
        text: `Não foi possível alterar a configuração: ${e.message}`,
      });

      this.setState({ loading: false });
    }
  }

  buildSelectOptions(options, selectedValue) {
    const builtOptions = options.map((option) => ({
      label: option.name,
      value: option.id,
      selected: option.id === selectedValue,
    }));

    return [
      {
        label: "Selecione",
        value: "",
        selected: !selectedValue,
      },
      ...builtOptions,
    ];
  }

  render() {
    const {
      loading,
      loadingPage,
      catalogId,
    } = this.state;
    const { visible, catalogs, onClose } = this.props;

    const isValid = catalogId;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        alreadyDrawer
        title={"Atena.ai - Cardápio"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Confirmar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Select
              design="two"
              label="Cardápio"
              onChange={(e) => this.setState({ catalogId: e.target.value })}
              className="mt-20"
              value={catalogId}
              options={this.buildSelectOptions(catalogs, catalogId)}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
